import React from 'react';
import cn from 'classnames'; // to use global class name eg. classes from grid.css in public folder
import styles from './BackgroundVideo.scss';// to import local scss fle

const BackgroundVideo = () => (
  <div className={cn('row', styles.videoContainer)}>
    <video className={cn('col s12', styles.videoWidth)} autoPlay loop muted>
      <source src="https://media.dev.myrecruitboard.com/Images/5571395.mov" type="video/mp4" />
    </video>
    <div className={styles.videoOverlay} />
  </div>
);

export default BackgroundVideo;



// WEBPACK FOOTER //
// ./src/components/Video/BackgroundVideo.js